import * as React from 'react';
import { colors } from './colors/color';
import { Flex } from './compositeComponents/FlexHelpers';
import { Icon, iconName } from './icons/Icons';
import { MaybeTooltipWrapper } from './TooltipTheOne';

type BadgeProps = {
    count?:number,
    tooltip?: React.ReactNode
    variant?:'success' | 'pending' | 'warning',
    icon?:iconName, // overrides variant
    color?:string,
}
export function Badge(props:BadgeProps):JSX.Element
{
    let icon:{name:iconName, color:string} = { name: 'help', color: colors.icon.passive };

    if(props.variant === 'success')
        icon = { name: 'status_ok', color: colors.icon.success };
    else if(props.variant === 'pending')
        icon = { name: 'navigation_clock', color: colors.icon.passive };
    else if(props.variant === 'warning')
        icon = { name: 'warning', color: colors.icon.warning };

    if(props.icon)
        icon.name = props.icon;
    if(props.color)
        icon.color = props.color;

    return (

        <MaybeTooltipWrapper tooltip={props.tooltip}>
            <Flex justifyContent="flex-end" alignItems="center" gap={2}>
                {props.count !== undefined &&
                    <span>
                        {props.count}
                    </span>
                }
                
                <Icon name={icon.name} color={icon.color} />
            </Flex>
        </MaybeTooltipWrapper>
    );
}



